export const COMMERCIAL_WARNINGS = {
    TAXI: "Использовался для работы в такси",
    CARSHARING: "Регистрировался для работы в каршеринге",
    LEASING: "Обнаружены сведения о договорах лизинга"
};

export const COMMERCIAL_OK = {
    LEASING: "Сведений о договорах лизинга не обнаружено"
};